export enum AuthMode {
  PASSWORD = 'password',
  SPID = 'spid',
  PASSKEY = 'passkey',
}
